import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { RelatedService } from './services/related.service';
import { ComposeService } from './services/compose.service';
import { EntrySearchService } from './services';

export function provideOutlookMainDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([
    RelatedService,
    ComposeService,
    EntrySearchService,
  ]);
}
